module.exports = __webpack_public_path__ + "img/appStoreDark.73e9933b.svg";